import { Controller } from "@hotwired/stimulus";
import { PolygonDrawing } from "../helpers/polygon_drawing";

export default class extends Controller {
  static targets = ["map", "polygonField", "clearButton", "drawButton"];
  static values = { apiKey: String };

  connect() {
    this.loadGoogleMapsAPI();
    this.polygon = null;
  }

  loadGoogleMapsAPI() {
    // Make initMap globally available for callback
    window.initSearchMapArea = () => this.initMap();

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${this.apiKeyValue}&loading=async&callback=initSearchMapArea`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }

  initMap() {
    const corneliusNC = { lat: 35.4816, lng: -80.8601 };
    const mapOptions = {
      center: corneliusNC,
      zoom: 12,
      mapTypeControl: true,
      streetViewControl: false,
      fullscreenControl: false,
    };
    this.map = new google.maps.Map(this.mapTarget, mapOptions);
    this.polygonDrawing = new PolygonDrawing(this.map, {
      polygonOptions: { clickable: true, editable: true, draggable: true },
      onFinish: (polygon) => this.finishDrawing(polygon),
    });
  }

  startDrawing() {
    this.polygonDrawing.start();
    this.drawButtonTarget.classList.add("hidden");
  }

  finishDrawing(polygon) {
    if (polygon) {
      this.polygon = polygon;
      this.updatePolygonCoordinates();

      google.maps.event.addListener(polygon.getPath(), "set_at", () =>
        this.updatePolygonCoordinates(),
      );
      google.maps.event.addListener(polygon.getPath(), "insert_at", () =>
        this.updatePolygonCoordinates(),
      );
      google.maps.event.addListener(polygon, "dragend", () =>
        this.updatePolygonCoordinates(),
      );
    }
    this.updateButtonsVisibility();
  }

  updatePolygonCoordinates() {
    if (this.polygon) {
      const path = this.polygon.getPath();
      const coordinates = path
        .getArray()
        .map((coord) => [coord.lat(), coord.lng()]);

      // Store coordinates array for google_map_polygon attribute
      this.polygonFieldTarget.value = JSON.stringify(coordinates);
    } else {
      this.polygonFieldTarget.value = "";
    }
  }

  clearPolygon(event) {
    event.preventDefault();
    if (this.polygon) {
      this.polygon.setMap(null);
      this.polygon = null;
      this.polygonFieldTarget.value = "";
      this.updateButtonsVisibility();
    }
  }

  updateButtonsVisibility() {
    this.clearButtonTarget.classList.toggle("hidden", !this.polygon);
    this.drawButtonTarget.classList.toggle("hidden", Boolean(this.polygon));
  }
}
